import * as Models from "../.";
import {MarketAssumedValuesBase} from ".";
export class SingleInvestorPricingAssumedValues extends MarketAssumedValuesBase.MarketAssumedValuesBase {
  defaultContractSignDate?: Date;
  epcCap: number;
  termLength: number;
  percentInvestmentAtContractSigning: number;
  percentInvestmentAtMechanicalCompletion: number;
  percentInvestmentAtPto: number;
  monthsFromContractSigningToMechanicalCompletion: number;
  monthsFromMechanicalCompletionToPto: number;
  developmentFeePercent: number;
  percentYield: number;
  percentDegredation: number;
  productionByMonth: { [key: number]: number };
  srecFactor: number;
  srecCommissionPercent: number;
  srecMintingPeriodLength: number;
  numberOfSrecYears: number;
  srecPriceIntervals: Models.MarketAssumedValuesModel.SrecPriceInterval[];
  relativeSrecSellingMonths: number[];
  operationManagementCostPerKw: number;
  operationManagementEscalator: number;
  operationManagementFreeStartYears: number;
  insuranceRate: number;
  insuranceEscalator: number;
  annualCellServiceFee: number;
  cellServiceFreeStartYears: number;
  cellServiceEscalator: number;
  inverterReplacementCostPerWatt: number;
  inverterReserveStartYear: number;
  inverterReplacementYear: number;
  assetManagementFeePerKw: number;
  systemRemovalNetRevenuePerWatt: number;
  investmentTaxCreditPercent: number;
  igsCorporateTaxRate: number;
  bonusDepreciationPercent: number;
  acceleratedDepreciationPoints: Models.MarketAssumedValuesModel.IAcceleratedDepreciationPoints[];
}
